export default __webpack_public_path__ + "static/media/subjectIcon.799eff8f.svg";